import React from 'react';

import './styles.css';

export default props => {
  return (
    <div className="Spreader" style={props.style}>
      {props.children}
    </div>
  );
};
